import type { Page } from '@reolink-web/bff-framework-press/client';

let cached: unknown | null = null;
const sharedModule = {
    onRenderIsomorphic(_ctx, props) {
        if (__isClientSide__) {
            if (cached) {
                return cached;
            }
            return (cached = props);
        }
        return props;
    },
} satisfies Page.IPageSharedModule<unknown, unknown>;

export default sharedModule;
